import { Spinner } from 'reactstrap'
import styled from 'styled-components'

//
const ESpinner = (props) => <StyleSpinner {...props} />

export default ESpinner

const StyleSpinner = styled(Spinner)``
